module.exports = __webpack_public_path__ + "static/media/dorp.e33ea3fe.jpg";